import { useQuery } from '@tanstack/react-query';

import { SPOTTER_SDK_TOKEN } from '@/api/oceansApi/constants';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';
import { APIResponse } from '@/common/types';

type GetOceansDevicesResult = { devices: { spotterId: string; nickname: string }[] };
export type OceansDevicesResponse = APIResponse<{ spotterId: string; name?: string }[]>;

export const getOceansDevices = (options?: RequestOptions): Promise<OceansDevicesResponse> => {
    return axios
        .get<
            GetOceansDevicesResult,
            APIResponse<GetOceansDevicesResult>
        >('/oceans-api/devices', { headers: { token: SPOTTER_SDK_TOKEN }, ...options })
        .then((response) => ({
            ...response,
            data: response.data?.devices?.map(({ spotterId, nickname: name }) => ({ spotterId, name })),
        }));
};

type UseOceansDevicesOptions = {
    config?: QueryConfig<typeof getOceansDevices>;
};

export const useOceansDevices = ({ config: { enabled = true, ...config } = {} }: UseOceansDevicesOptions) => {
    return useQuery<OceansDevicesResponse>({
        queryKey: ['oceans-devices'],
        queryFn: ({ signal }) => getOceansDevices({ signal }),
        staleTime: 3600,
        enabled,
        ...config,
    });
};
